export const loadFromairtable = async ({
  apiKey = "",
  baseName = "appmRFrX37zHX2j1O",

  tableName = "resource_permistions",

  viewName = "Grid view",

  tag = "main",

  fields = [],
}) => {
  var commaSeparatedString = fields.join(",");

  //console.log(`https://ra-config.rafed.io/api/refresh/${baseName}/${tableName}?columns=${commaSeparatedString}&tag=main`)

  const response = await fetch(
    `${import.meta.env.REACT_APP_AIRTABLE_API_URI}?base=${baseName}&name=${tableName}&tag=${tag}`
  );

  const data = await response.json();

  return data.base[0].data;
};
